module.exports = __webpack_public_path__ + "img/I.6e18145f.png";